import cls from "./productComments.module.scss";
import { useTranslation } from "react-i18next";
import ArrowRightSLineIcon from "remixicon-react/ArrowRightSLineIcon";
import { IReview } from "interfaces/review.interface";
import HorizontalLine from "components/line/horizontalLine";
import Image from "next/image";
import React, { Fragment } from "react";
import ProductReviewCard from "./productReviewCard";

type Props = {
  data?: IReview[];
  handleOpenReviews?: () => void;
};

export default function ProductComments({ data, handleOpenReviews }: Props) {
  const { t } = useTranslation();
  return (
    <div className={cls.container}>
      <div className={cls.header}>
        <h2 className={cls.title}>{t("reviews")}</h2>
        <button
          type="button"
          className={cls.seeAllButton}
          onClick={handleOpenReviews}
        >
          {t("see.all")}
          <ArrowRightSLineIcon size={24} />
        </button>
      </div>
      <HorizontalLine color="var(--grey)" margin="20px 0" />
      <div className={cls.listContainer}>
        {data?.length ? (
          data?.map((item, index) => (
            <Fragment key={item?.id}>
              {index !== 0 && (
                <HorizontalLine color="var(--grey)" margin="20px 0" />
              )}
              <ProductReviewCard data={item} />
            </Fragment>
          ))
        ) : (
          <div className={cls.emptyContainer}>
            <Image
              src="/images/delivery.webp"
              alt={t("empty")}
              width={200}
              height={200}
            />
            <p>{t("no.comments")}</p>
          </div>
        )}
      </div>
    </div>
  );
}
